import { render, staticRenderFns } from "./MusculoskeletalTensionExercisesTable.vue?vue&type=template&id=e661e380&scoped=true"
import script from "./MusculoskeletalTensionExercisesTable.vue?vue&type=script&lang=js"
export * from "./MusculoskeletalTensionExercisesTable.vue?vue&type=script&lang=js"
import style0 from "./MusculoskeletalTensionExercisesTable.vue?vue&type=style&index=0&id=e661e380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e661e380",
  null
  
)

export default component.exports